import { computed, observable } from 'mobx';
import JsonService from '@src/services/json';
import Redirection from '@src/utils/redirection';
import FACEBOOK from "./images/Facebook.png";
import GOOGLE from "./images/Google.png";
import TWITTER from "./images/Twitter.png";
import APPLE from "./images/Apple.png";
export const THIRD_PARTY_TYPE = {
  facebook: 'facebook',
  google: 'google',
  twitter: 'twitter',
  googleplay: 'googleplay',
  gamecenter: 'gamecenter',
  appleid: 'appleid'
};

export const THIRD_PARTY_NAME = {
  facebook: 'Facebook',
  google: 'Google',
  twitter: 'Twitter',
  googleplay: 'Googleplay',
  gamecenter: 'Gamecenter',
  appleid: 'AppleId'
};

export const THIRD_PARTY_ICON = {
  facebook: FACEBOOK,
  google: GOOGLE,
  twitter: TWITTER,
  googleplay: GOOGLE,
  gamecenter: APPLE,
  appleid: APPLE
};

/**
 * 关联账号
 */
export default class AssociatedAccountStore {
  $service = JsonService.getZTDefaultInstance({});

  /**
   * 第三方绑定 名称
   * @type {string}
   */
  @observable thirdPartyType = '';
  /**
   * 绑定状态
   * @type {boolean}
   */
  @observable bindStatus = false;
  /**
   * 第三方账号名称
   * @type {string}
   */
  @observable nickname = '';

  @computed
  get name() {
    return THIRD_PARTY_NAME[this.thirdPartyType];
  }

  /**
   * 图标
   * @type {string}
   */
  @observable icon = '';

  /**
   * 构建函数
   * @param thirdPartyType
   * @param bindStatus
   * @param nickname
   */
  constructor({ thirdPartyType, bindStatus, nickname }) {
    this.thirdPartyType = THIRD_PARTY_TYPE[thirdPartyType];
    this.icon = THIRD_PARTY_ICON[thirdPartyType];
    this.bindStatus = bindStatus;
    this.nickname = nickname;
  }
}
